import { faStore } from '@fortawesome/pro-light-svg-icons'

import { DashboardModule, Link } from '@domain-group/suit-theme'

import useAgencies from '@hooks/useAgencies'

import AgenciesTable from './AgenciesTable'

export const icon = faStore

export const configOptions = () => ({
  limit: {
    component: 'select',
    key: 'limit',
    label: 'Limit',
    optionKey: 'queryParams',
    values: [
      { key: 10, label: '10' },
      { key: 25, label: '25' },
      { key: 50, label: '50' },
    ],
  },
})

interface AgenciesProps {
  customOptions: {
    queryParams: {
      limit?: number,
    },
  },
}

const Agencies = (props: AgenciesProps) => {
  const {
    customOptions: {
      queryParams,
    },
  } = props

  const { limit } = queryParams || {}

  const agenciesPayload = useAgencies({
    filters: {
      active: 'true',
      limit: limit || 10,
      order_by: 'updated_at DESC',
    },
    performHttpRequests: true,
    skipLoadedForKeysCheck: true,
    sortBy: 'cache_key desc',
  })

  const {
    filteredAgencies, hasFilteredAgencies, loading,
  } = agenciesPayload

  const agenciesArray = filteredAgencies.slice(0, limit)

  return (
    <DashboardModule
      boxProps={{ marginBottom: 0 }}
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={(
        <Link
          href="#/systemManager/agencies"
          textProps={{ fontSize: 'xsmall' }}
        >
          View All Agencies
        </Link>
      )}
      loading={loading}
      title="Agencies"
    >
      <DashboardModule.ScrollableSection>
        {hasFilteredAgencies && !loading && (
          <AgenciesTable agencies={agenciesArray} />
        )}
      </DashboardModule.ScrollableSection>

      {!loading && !hasFilteredAgencies && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Agencies Present.
          </DashboardModule.BlankState.Title>
        </DashboardModule.BlankState>
      )}
    </DashboardModule>
  )
}

export default Agencies
